import { c as _c } from "react/compiler-runtime";
import { type GenuinePartItemProps } from '@/app/components/sections/service/parts/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { formatPrice, getPartPrefix } from '@/app/utils/format';
import { BATTERY_TIRE } from '@/services/parts/const';
export const PartItem = t0 => {
  const $ = _c(27);
  const {
    categoryUrl,
    genuinePart,
    index,
    testId
  } = t0;
  if (!genuinePart) {
    return null;
  }
  const specialPrice = parseFloat(`${genuinePart.specialPrice}`);
  let t1;
  if ($[0] !== genuinePart) {
    t1 = getPartPrefix(genuinePart);
    $[0] = genuinePart;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const prefix = t1;
  const t2 = !genuinePart?.showStartPricePrefix && !!prefix;
  let t3;
  if ($[2] !== t2) {
    t3 = cn("flex justify-center", {
      "justify-between": t2
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${testId}-part-${index}`;
  let t5;
  if ($[4] !== t4) {
    t5 = createDataAttributes({
      test: t4
    });
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== genuinePart.showStartPricePrefix || $[7] !== index || $[8] !== prefix || $[9] !== testId) {
    t6 = !genuinePart?.showStartPricePrefix && <p className="where-span:text-inline-wrap" dangerouslySetInnerHTML={{
      __html: prefix
    }} {...createDataAttributes({
      test: `${testId}-part-${index}-title`
    })} />;
    $[6] = genuinePart.showStartPricePrefix;
    $[7] = index;
    $[8] = prefix;
    $[9] = testId;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== categoryUrl || $[12] !== genuinePart.price || $[13] !== specialPrice) {
    t7 = categoryUrl === BATTERY_TIRE && specialPrice > 0 ? formatPrice(specialPrice, "none") : formatPrice(genuinePart.price, "none");
    $[11] = categoryUrl;
    $[12] = genuinePart.price;
    $[13] = specialPrice;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `${genuinePart.showStartPricePrefix ? "\u0E40\u0E23\u0E34\u0E48\u0E21" : ""} ${t7} ${genuinePart.unit ?? ""}`;
  let t9;
  if ($[15] !== t8) {
    t9 = {
      __html: t8
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `${testId}-part-${index}-price-unit`;
  let t11;
  if ($[17] !== t10) {
    t11 = createDataAttributes({
      test: t10
    });
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t9) {
    t12 = <p className="font-noto-bold where-span:text-inline-wrap text-red-500" dangerouslySetInnerHTML={t9} {...t11} />;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t3 || $[24] !== t5 || $[25] !== t6) {
    t13 = <div className={t3} {...t5}>{t6}{t12}</div>;
    $[22] = t12;
    $[23] = t3;
    $[24] = t5;
    $[25] = t6;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};